<template>
	<div>
		<img
		class=""
		width="100px"
		style="position: absolute;"
		:src="require('../../../assets/img/Illustration_Home_2_1.svg')"
		data-aos="fade-up"
		data-aos-duration="3000"
		alt="با برترین مدرس ها، مربیان و اساتید در تمامی رشته ها و مقاطع"
		title="با برترین مدرس ها، مربیان و اساتید در تمامی رشته ها و مقاطع"
		/>
		<div class="w-100 overflow-hidden p-3 mt-3"
		:style="'background-image: url('+require('../../../assets/img/Back_Up.svg')+');'"
		style="
    	background-repeat: no-repeat;
    	background-position: top;
    	background-size: cover;
		">
			<div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 p-3 float-right">
				<h2
				class="bMikhak text-success"
				style="margin-top: 100px;"
				data-aos="fade-up"
				data-aos-duration="3000"
				:class="(windowWidth < 990) ? 'text-center' : ''"
				>
					با برترین مدرس ها، مربیان و اساتید
					<br/>
					در تمامی رشته ها و مقاطع
				</h2>
				<p
				class="text-justify rtl"
				data-aos="fade-up"
				data-aos-duration="3000"
				>
				جلسه‌ی تدریس خصوصی، می‌تواند بصورت آنلاین یا حضوری باشد. جلسه‌ی آنلاین می‌تواند بصورت تصویری، صوتی یا چت برگزار شود. همچنین جلسه‌ی تدریس خصوصی حضوری می‌تواند در محل کاربر یا محل تدریس مدرس انجام شود که تمامی این تنظیمات دراختیار کاربران می‌باشد.

				</p>
				<!-- *********************************** -->
				<div class="row" dir="rtl">
					<div class="col-sm-12 col-md-12 col-lg-5 col-xl-5">
						<a href="/teachers">
							<btn
								type="success"
								text = "مشاهده همه مدرس ها"
								textClass="w-100"
							/>
						</a>
					</div>
					<div class="col-sm-12 col-md-12 col-lg-5 col-xl-5" :class="(windowWidth < 990) ? 'mt-3' : ''">
						<router-link to="/aboutme">
							<btn
								dir="rtl"
								class=""
								type="outline-success"
								text="بیشتر بدانید"
								textClass="text-white w-100"
								
								:img="require('../../../assets/img/Arrow_Left.svg')"
							/>
						</router-link>
					</div>
				</div>
				<!-- *********************************** -->
			</div>
			<div class="col-lg-6 col-md-6 col-sm-12 col-xs-12 p-3 mt-3 float-right">
				<img
					class="w-100 mt-3"
					:src="require('../../../assets/img/Illustration_Home_2.svg')"
					data-aos="fade-right"
					data-aos-duration="3000"
					alt="با برترین مدرس ها، مربیان و اساتید در تمامی رشته ها و مقاطع"
					title="با برترین مدرس ها، مربیان و اساتید در تمامی رشته ها و مقاطع"
				/>
			</div>
		</div>
	</div>
</template>

	<script>
		import btn from  "../../../UI/button/btn.vue";
		import ArrowLeft from '../../../assets/img/Arrow_Left.svg';
		export default {
			name: 'p_home3',
			data(){
				return {
					img: {
							"ArrowLeft": ArrowLeft,
					}
				}
			},
			components: {
				btn,
				ArrowLeft,
			},
			props: [],
			mounted(){

			},
			methods:{

			}
		}
	</script>
<style>

</style>
